export const handlePaste = (event: any) => {
  // Get the pasted data via clipboardData
  const pasteData = event.clipboardData.getData("text");

  // Define the specific characters you want to block
  const blockedCharacters = [
    "!",
    '"',
    "#",
    "$",
    "%",
    "&",
    "'",
    "(",
    ")",
    "*",
    "+",
    ",",
    "-",
    ".",
    "/",
    ":",
    ";",
    "<",
    "=",
    ">",
    "?",
    "@",
    "[",
    "\\",
    "]",
    "^",
    "_",
    "`",
    "{",
    "|",
    "}",
    "~",
  ];

  // Check if the pasted data contains any blocked characters
  for (let i = 0; i < blockedCharacters.length; i++) {
    if (pasteData.includes(blockedCharacters[i])) {
      // Cancel the paste event if it contains blocked characters
      event.preventDefault();
      alert(`Pasting the character '${blockedCharacters[i]}' is not allowed.`);
      return;
    }
  }
};

export const pushToDataLayer = (data: any) => {
  (window as any).dataLayer = (window as any).dataLayer || [];
  (window as any).dataLayer.push(data);
}